/**
 * What the contact's working sheet shows (PLAN-ENCRE-OUTILS O2, mock-up « Encre-Fiche »): the name
 * as said, the account it works for, the ways to reach it, primary first. Read from the contact as
 * `readContact` gives it. Pure.
 */
import type { CRMContact } from '../../types/crm';

/** « Sandrine Delmas », never an empty string. */
export function contactName(contact: Pick<CRMContact, 'first_name' | 'last_name'>): string {
  return `${contact.first_name ?? ''} ${contact.last_name ?? ''}`.trim() || 'Contact sans nom';
}

/**
 * The account the contact works for: the link matching its main account (`account_id`), else the
 * primary link, else the first — by its key, with the name the link carries.
 */
export function primaryAccountOf(contact: Pick<CRMContact, 'account_id' | 'contact_accounts'>): { id: string; name: string } | null {
  const links = contact.contact_accounts ?? [];
  const link = links.find((ca) => ca.account_id === contact.account_id) ?? links.find((ca) => ca.is_primary) ?? links[0];
  return link?.account ? { id: link.account.id, name: link.account.name } : null;
}

/** Mails, phones or links with the primary one first. */
export function primaryFirst<T extends { is_primary?: boolean | null }>(items: readonly T[] | undefined): T[] {
  return [...(items ?? [])].sort((a, b) => Number(Boolean(b.is_primary)) - Number(Boolean(a.is_primary)));
}

/** The address to write to and the number to call: the primary ones, else the contact's own fields. */
export function reachOf(contact: Pick<CRMContact, 'email' | 'phone' | 'emails' | 'phones'>): { email: string | null; phone: string | null } {
  return {
    email: primaryFirst(contact.emails)[0]?.email ?? contact.email ?? null,
    phone: primaryFirst(contact.phones)[0]?.phone ?? contact.phone ?? null,
  };
}
